import React from 'react';
import { situations } from '../../data/content';
import { SectionHeading } from '../SectionHeading';
import { CTAButton } from '../CTAButton';
export function Situations() {
  return <section className="bg-white px-4 py-16 sm:py-24" aria-labelledby="situations-title" data-id="element-252" data-mp="2tfcbgshavx2v">
      <div className="mx-auto max-w-5xl" data-id="element-253" data-mp="2ogiyr29u8a3r">
        <SectionHeading title={<span id="situations-title" data-id="element-255" data-mp="2oeeswesdp10u">Do any of these situations sound familiar?</span>} subtitle={<>If you answer <strong className="text-ink" data-id="element-256" data-mp="2eibh0h7q5o0p">YES</strong> to even one, I created this system for you.</>} data-id="element-254" data-mp="2ofpvwce024qw" />

        <ul className="mt-12 grid gap-4 md:grid-cols-2" data-id="element-257" data-mp="2aggh9h5fzip1">
          {situations.map(({
          icon: Icon,
          text
        }) => <li key={text} className="flex gap-4 rounded-2xl bg-cream p-5" data-id="element-258" data-mp="25i6ikwkidzyo">
              <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-xl bg-brand text-white" data-id="element-259" data-mp="8pd3ij099o09">
                <Icon className="h-5 w-5" aria-hidden="true" data-id="element-260" data-mp="3pqsmg7wgjum" />
              </span>
              <p className="text-[16px] leading-relaxed text-ink" data-id="element-261" data-mp="1353bqwcj8dzg">{text}</p>
            </li>)}
        </ul>

        <div className="mx-auto mt-12 max-w-2xl space-y-4 text-center text-[17px] leading-relaxed text-ink/85 sm:text-lg" data-id="element-262" data-mp="184ppr806py9b">
          <p className="font-serif text-2xl font-bold text-ink" data-id="element-263" data-mp="u5ghqvm4uagf">And it shouldn’t have to feel this complicated.</p>
          <p data-id="element-264" data-mp="z41jx0ky347i">Because the problem isn’t necessarily your knowledge.</p>
          <p data-id="element-265" data-mp="1msua0gevyhu7">
            Sometimes, what is missing is <strong className="text-brand-dark" data-id="element-266" data-mp="1mv705gusryic">a clear route for turning your clinical reasoning into the next step.</strong>
          </p>
        </div>

        <div className="mt-10" data-id="element-267" data-mp="1d42lki91afo1">
          <CTAButton label="I want a structured clinical route" data-id="element-268" data-mp="1d30y1eau00pf" />
        </div>
      </div>
    </section>;
}